import React from 'react';
import { Body, Headline, Heading } from './components';
export const Text = (props) => {
    switch (props.type) {
        case 'body':
            return React.createElement(Body, Object.assign({}, props, { type: 'body' }));
        case 'headline':
            return React.createElement(Headline, Object.assign({}, props, { type: 'headline' }));
        case 'heading':
            return React.createElement(Heading, Object.assign({}, props, { type: 'heading' }));
    }
};
//# sourceMappingURL=index.js.map